import { render, staticRenderFns } from "./LiteracyComponent5.vue?vue&type=template&id=4efb5238&scoped=true&"
import script from "./LiteracyComponent5.vue?vue&type=script&lang=js&"
export * from "./LiteracyComponent5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efb5238",
  null
  
)

export default component.exports